module.exports = __webpack_public_path__ + "img/FR11999.11c680a4.png";